import React, { createContext, useContext } from 'react';

import { useOnboarding, UseOnboardingReturn } from '@/hooks/useOnboarding';

const OnboardingContext = createContext<UseOnboardingReturn | null>(null);

export function OnboardingProvider({ children }: { children: React.ReactNode }): React.ReactElement {
  const onboarding = useOnboarding();
  return (
    <OnboardingContext.Provider value={onboarding}>
      {children}
    </OnboardingContext.Provider>
  );
}

export function useOnboardingContext(): UseOnboardingReturn {
  const context = useContext(OnboardingContext);
  if (!context) {
    throw new Error('useOnboardingContext must be used within OnboardingProvider');
  }
  return context;
}

/**
 * Safe hook for trigger components — returns no-op if outside OnboardingProvider.
 */
export function useOnboardingMark(): () => void {
  const context = useContext(OnboardingContext);
  if (!context) return () => {};
  return context.markFirstEditIfNeeded;
}
